import { Box, Card, Divider, Typography } from "@mui/material";
import { Home as HomeIcon, Person as PersonIcon, Receipt as ReceiptIcon } from "@mui/icons-material";
import { ClienteInfo } from "../types/payment";

interface CardDetailsProps {
	clienteInfo: ClienteInfo;
}

const CardDetails = ({ clienteInfo }: CardDetailsProps) => {

	console.log('01...',clienteInfo);
	return (
		<Card sx={{ p: 3, flex: 1, width: { xs: "100%", md: "50%" } }}>
			<Typography variant="h6" gutterBottom>
				Detalhes da Assinatura
			</Typography>

			<Box sx={{ mb: 3 }}>
				<Typography variant="body2" color="text.secondary" gutterBottom>
					Imobiliária
				</Typography>
				<Typography variant="subtitle1" fontWeight="medium">
					{clienteInfo?.imobiliaria || "carregando..."}
				</Typography>
			</Box>

			<Divider sx={{ my: 2 }} />

			<Box sx={{ mb: 3 }}>
				<Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
					<PersonIcon sx={{ color: "primary.main", mr: 1, fontSize: 20 }} />
					<Typography variant="subtitle2">Cliente</Typography>
				</Box>
				<Box sx={{ pl: 3.5 }}>
					<Typography variant="body1">{clienteInfo.nome}</Typography>
					<Typography variant="body2" color="text.secondary">
						CPF: {clienteInfo.cpf}
					</Typography>
				</Box>
			</Box>

			<Box sx={{ mb: 3 }}>
				<Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
					<HomeIcon sx={{ color: "primary.main", mr: 1, fontSize: 20 }} />
					<Typography variant="subtitle2">Endereço do Imóvel</Typography>
				</Box>
				<Box sx={{ pl: 3.5 }}>
					<Typography variant="body1">
						{clienteInfo?.imovel?.endereco}
						</Typography>
					<Typography variant="body2" color="text.secondary">
						CEP: {clienteInfo.imovel?.cep}
					</Typography>
				</Box>
			</Box>

			<Divider sx={{ my: 2 }} />

			<Box>
				<Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
					<ReceiptIcon sx={{ color: "primary.main", mr: 1, fontSize: 20 }} />
					<Typography variant="subtitle2">Valores</Typography>
				</Box>

				<Box
					sx={{
						pl: 3.5,
						pr: 2,
						py: 2,
						bgcolor: "rgba(138, 43, 226, 0.03)",
						borderRadius: 1,
						border: "1px solid rgba(138, 43, 226, 0.1)",
					}}
				>
					<Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
						<Typography variant="body2" color="text.secondary">
							Garantia Locatícia
						</Typography>
						<Typography variant="body1">R$ 
							{clienteInfo.valores?.garantiaLocaticia.toFixed(2).replace(".", ",") || "0,00"}
							</Typography>
					</Box>

					<Divider sx={{ my: 2 }} />

					<Box sx={{ display: "flex", justifyContent: "space-between" }}>
						<Typography variant="subtitle1" fontWeight="bold">
							Total
						</Typography>
						<Typography variant="h6" fontWeight="bold" color="primary.main">
							{clienteInfo.valores?.total.toFixed(2).replace(".", ",") || "0,00"}
						</Typography>
					</Box>
				</Box>
			</Box>
		</Card>
	);
};

export default CardDetails;
